module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/header@2x-dba9ed7817715da774f8c44ec5f902f9.png";